<div
  class="self-pay-cost-estimate-detailed"
  [class.stand-alone]="standAlone()"
  data-test="self-pay-cost-estimate-detailed"
>
  <button
    type="button"
    class="trigger"
    (click)="toggle()"
    [attr.aria-expanded]="expanded()"
    aria-controls="self-pay-cost-estimate-detailed-content"
    id="self-pay-cost-estimate-detailed-trigger"
    data-test="self-pay-cost-estimate-detailed-trigger"
  >
    <span class="label">View all self-pay estimates</span>
    <iris-icon
      [name]="expanded() ? 'expand_less' : 'expand_more'"
      [size]="iconSizes.MD"
      [color]="iconColors.BRAND1"
      aria-hidden="true"
      class="icon"
    ></iris-icon>
  </button>

  @if (expanded()) {
    <div
      class="content"
      id="self-pay-cost-estimate-detailed-content"
      aria-labelledby="self-pay-cost-estimate-detailed-trigger"
      data-test="self-pay-cost-estimate-detailed-content"
    >
      @if (standAlone() && ratesLoading()) {
        <div data-test="self-pay-cost-estimate-detailed-rates-loading">
          <iris-spinner [size]="'sm'"></iris-spinner>
        </div>
      } @else {
      <div class="all-estimates-content">
        <p class="all-estimates-disclaimer">
          Costs can vary depending on the length of your session or which services you receive.
        </p>

        @for (category of detailedEstimates(); track category.categoryLabel) {
          <div class="estimate-category">
            <p class="estimate-category-heading">{{ category.categoryLabel }}</p>

            <ul class="estimate-category-list">
              @for (item of category.items; track item.label + (item.amount ?? 'N/A')) {
                <li class="estimate-category-row">
                  <p class="estimate-item">{{ item.label }}</p>
                  <p class="estimate-item">{{ item.amount != null ? (item.amount | currency:'USD':'symbol':'1.0-2') : 'N/A' }}</p>
                </li>
              }
            </ul>
          </div>
        }
      </div>
      }
    </div>
  }
</div>
